import type { StoreProductReapproParamUpsert } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const upsertStoreProductReapproParam = async (data: StoreProductReapproParamUpsert) => {
  const response = await gozokiApiWithAuth.put('/store-product-reappro-params', data)
  return response.data
}
